import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Users, BookOpen, MessageCircle, Eye } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Card, CardContent } from "@/components/ui/card";

const fadeInUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
};

const staggerContainer = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.15 } },
};

const portfolioItems = [
  {
    icon: MessageCircle,
    title: "Beratung",
    description: "Strategische Beratung und Begleitung von Veränderungsprozessen in Organisationen.",
    href: "/portfolio/beratung",
  },
  {
    icon: BookOpen,
    title: "Qualifizierung",
    description: "Qualifizierungsprogramme und Workshops für nachhaltige Kompetenzentwicklung.",
    href: "/portfolio/qualifizierung",
  },
  {
    icon: Users,
    title: "Coaching",
    description: "Individuelle Begleitung für Führungskräfte und Teams zur persönlichen Weiterentwicklung.",
    href: "/portfolio/coaching",
  },
  {
    icon: Eye,
    title: "Supervision",
    description: "Professionelle Reflexion und Begleitung für Fachkräfte und Teams.",
    href: "/portfolio/supervision",
  },
];

const Portfolio = () => (
  <>
    <Header />
    <main className="py-20 md:py-28">
      <div className="container">
        <motion.div
          initial="hidden"
          animate="visible"
          variants={staggerContainer}
          className="text-center mb-14"
        >
          <motion.p variants={fadeInUp} className="text-sm font-semibold uppercase tracking-widest text-primary mb-3">
            Was wir tun
          </motion.p>
          <motion.h1 variants={fadeInUp} className="text-4xl md:text-5xl font-serif font-bold text-foreground mb-4">
            Unser Portfolio
          </motion.h1>
          <motion.p variants={fadeInUp} className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Entdecken Sie unsere vier Kernbereiche – maßgeschneidert für Ihre Herausforderungen.
          </motion.p>
        </motion.div>

        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
          variants={staggerContainer}
          className="grid grid-cols-1 md:grid-cols-2 gap-6"
        >
          {portfolioItems.map((item) => (
            <motion.div key={item.title} variants={fadeInUp}>
              <Link to={item.href}>
                <Card className="h-full border-border/50 hover:border-primary/30 hover:shadow-lg transition-all duration-300 group cursor-pointer">
                  <CardContent className="p-8">
                    <div className="mb-5 flex h-12 w-12 items-center justify-center rounded-xl bg-primary/10 text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-colors duration-300">
                      <item.icon className="h-6 w-6" />
                    </div>
                    <h2 className="text-xl font-semibold text-foreground mb-2 font-serif">{item.title}</h2>
                    <p className="text-muted-foreground leading-relaxed">{item.description}</p>
                  </CardContent>
                </Card>
              </Link>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </main>
    <Footer />
  </>
);

export default Portfolio;
